export const BASEMAP_STYLES = [
  {
    style: "outdoors-v11",
    name: "Outdoors",
    url: "mapbox://styles/mapbox/outdoors-v11",
  },
  {
    style: "streets-v11",
    name: "Streets",
    url: "mapbox://styles/mapbox/streets-v11",
  },
  {
    style: "satellite-streets-v11",
    name: "Satellite",
    url: "mapbox://styles/mapbox/satellite-streets-v11",
  },
  {
    style: "light-v10",
    name: "Light",
    url: "mapbox://styles/mapbox/light-v10",
  },
  {
    style: "dark-v10",
    name: "Dark",
    url: "mapbox://styles/mapbox/dark-v10",
  },
];

export const DEFAULT_MAP_CENTER = [-105.13619, 40.41093];

export const INIT_MAP_CONFIG = {
  style: BASEMAP_STYLES[0].url,
  center: DEFAULT_MAP_CENTER,
  zoom: 9,
  preserveDrawingBuffer: true,
};

export const WELLS_LAYER_ID = "greeley-locations-circle";
export const WELLS_LABELS_LAYER_ID = "greeley-locations-symbol";
export const INIT_FILTER_VALUES = {
  locationTypes: {
    label: "Location Types",
    name: "locationTypes",
    layerId: WELLS_LAYER_ID,
    layerFieldName: "locationtype",
    options: [],
    type: "multi-select",
    value: [],
  },
  streamSegments: {
    label: "Stream Segments",
    name: "streamSegments",
    layerId: WELLS_LAYER_ID,
    layerFieldName: "stream_segment",
    options: [],
    type: "multi-select",
    value: [],
  },
  organizations: {
    name: "organizations",
    label: "Organizations",
    layerId: WELLS_LAYER_ID,
    layerFieldName: "organizations",
    options: [],
    type: "multi-select-array",
    value: [],
  },
  graphMode: {
    layerId: WELLS_LAYER_ID,
    layerFieldName: "ndx",
    type: "graphMode",
    value: [""],
  },
  moreThanA: {
    label: "More Filters",
    layerId: WELLS_LAYER_ID,
    layerFieldName: "more_than_a",
    type: "boolean",
    value: false,
  },
  moreThanB: {
    label: "More Filters",
    layerId: WELLS_LAYER_ID,
    layerFieldName: "more_than_b",
    type: "boolean",
    value: false,
  },
  moreThanC: {
    label: "More Filters",
    layerId: WELLS_LAYER_ID,
    layerFieldName: "more_than_c",
    type: "boolean",
    value: false,
  },
  dataRecentA: {
    label: "More Filters",
    layerId: WELLS_LAYER_ID,
    layerFieldName: "data_recent_a",
    type: "boolean",
    value: false,
  },
  dataRecentB: {
    label: "More Filters",
    layerId: WELLS_LAYER_ID,
    layerFieldName: "data_recent_b",
    type: "boolean",
    value: false,
  },
};

const layerId = "greeley-locations-circle";
export const INIT_STYLE_VALUES = {
  default: {
    id: "default",
    layerId,
    layerFieldName: "",
    name: "Default",
    paint: {
      "circle-color": "#1e8dd2",
      "circle-stroke-width": 1,
      "circle-stroke-color": "#fff",
    },
  },
  locationTypes: {
    id: "locationTypes",
    layerId,
    layerFieldName: "locationtype",
    name: "Location Types",
    options: [],
    type: "multi-select",
    value: [],
    paint: {
      "circle-color": [
        "match",
        ["get", "locationtype"],
        "No Values Available",
        "#fff",
        "#fff",
      ],
    },
  },
  streamSegments: {
    id: "streamSegments",
    layerId,
    layerFieldName: "stream_segment",
    name: "Stream Segments",
    options: [],
    type: "multi-select",
    value: [],
    paint: {
      "circle-color": [
        "match",
        ["get", "stream_segment"],
        "No Values Available",
        "#fff",
        "#fff",
      ],
    },
  },
  organizations: {
    id: "organizations",
    layerId,
    layerFieldName: "organizations",
    name: "Organizations",
    options: [],
    type: "multi-select-array",
    value: [],
    paint: {
      "circle-color": [
        "match",
        ["get", "org_fav"],
        "No Values Available",
        "#fff",
        "#fff",
      ],
    },
  },
};
